new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
      
    },
})

$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const footerSection = document.querySelectorAll('.footer-section');
        if(footerSection.length) {
            footerSection.forEach((item) => {
                let footerTitle = item.querySelector('.footer-title');
                let footerContent = item.querySelector('.footer-section--content');
                if(footerTitle && footerContent) {
                    footerTitle.addEventListener('click', () => {
                        footerTitle.classList.toggle('active');
                        footerContent.classList.toggle('active');
                    });
                }
            });
        }
    }

    $('#faixa-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    })
});